import { render, staticRenderFns } from "./Blog4.vue?vue&type=template&id=b3dbfd56"
import script from "./Blog4.vue?vue&type=script&lang=js"
export * from "./Blog4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports